// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V1SourceBackup } from './V1SourceBackup';
import {
  V1SourceBackupFromJSON,
  V1SourceBackupFromJSONTyped,
  V1SourceBackupToJSON,
  V1SourceBackupToJSONTyped,
} from './V1SourceBackup';
import type { V1StorageClassParameters } from './V1StorageClassParameters';
import {
  V1StorageClassParametersFromJSON,
  V1StorageClassParametersFromJSONTyped,
  V1StorageClassParametersToJSON,
  V1StorageClassParametersToJSONTyped,
} from './V1StorageClassParameters';

/**
 *
 * @export
 * @interface V1Neo4jDatabaseSettings
 */
export interface V1Neo4jDatabaseSettings {
  /**
   *
   * @type {V1StorageClassParameters}
   * @memberof V1Neo4jDatabaseSettings
   */
  coreStorageClass?: V1StorageClassParameters;
  /**
   *
   * @type {number}
   * @memberof V1Neo4jDatabaseSettings
   */
  disk?: number;
  /**
   *
   * @type {string}
   * @memberof V1Neo4jDatabaseSettings
   */
  memory?: string;
  /**
   *
   * @type {string}
   * @memberof V1Neo4jDatabaseSettings
   */
  neo4jConfiguration?: string;
  /**
   * This is the full Neo4j drop/version name, e.g. "4.3.2-drop10" or "3.6.19", not just major version
   * @type {string}
   * @memberof V1Neo4jDatabaseSettings
   */
  neo4jVersion?: string;
  /**
   *
   * @type {V1SourceBackup}
   * @memberof V1Neo4jDatabaseSettings
   */
  originBackup?: V1SourceBackup;
  /**
   *
   * @type {number}
   * @memberof V1Neo4jDatabaseSettings
   */
  virtDisk?: number;
}

/**
 * Check if a given object implements the V1Neo4jDatabaseSettings interface.
 */
export function instanceOfV1Neo4jDatabaseSettings(
  value: object,
): value is V1Neo4jDatabaseSettings {
  return true;
}

export function V1Neo4jDatabaseSettingsFromJSON(
  json: any,
): V1Neo4jDatabaseSettings {
  return V1Neo4jDatabaseSettingsFromJSONTyped(json, false);
}

export function V1Neo4jDatabaseSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1Neo4jDatabaseSettings {
  if (json == null) {
    return json;
  }
  return {
    coreStorageClass:
      json['coreStorageClass'] == null
        ? undefined
        : V1StorageClassParametersFromJSON(json['coreStorageClass']),
    disk: json['disk'] == null ? undefined : json['disk'],
    memory: json['memory'] == null ? undefined : json['memory'],
    neo4jConfiguration:
      json['neo4jConfiguration'] == null
        ? undefined
        : json['neo4jConfiguration'],
    neo4jVersion:
      json['neo4jVersion'] == null ? undefined : json['neo4jVersion'],
    originBackup:
      json['originBackup'] == null
        ? undefined
        : V1SourceBackupFromJSON(json['originBackup']),
    virtDisk: json['virtDisk'] == null ? undefined : json['virtDisk'],
  };
}

export function V1Neo4jDatabaseSettingsToJSON(
  json: any,
): V1Neo4jDatabaseSettings {
  return V1Neo4jDatabaseSettingsToJSONTyped(json, false);
}

export function V1Neo4jDatabaseSettingsToJSONTyped(
  value?: V1Neo4jDatabaseSettings | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    coreStorageClass: V1StorageClassParametersToJSON(value['coreStorageClass']),
    disk: value['disk'],
    memory: value['memory'],
    neo4jConfiguration: value['neo4jConfiguration'],
    neo4jVersion: value['neo4jVersion'],
    originBackup: V1SourceBackupToJSON(value['originBackup']),
    virtDisk: value['virtDisk'],
  };
}
